/**
 * Rollbar が利用可能な場合は Rollbar へ、そうでない場合は console へ出力するロガー
 */
const rollbar = () => {
  if (typeof globalThis === "undefined") return null;
  return globalThis.Rollbar || null;
};

export const logger = {
  error(message, ...args) {
    const rb = rollbar();
    if (rb) {
      rb.error(message, ...args);
    } else {
      console.error(message, ...args);
    }
  },

  warn(message, ...args) {
    const rb = rollbar();
    if (rb) {
      rb.warning(message, ...args);
    } else {
      console.warn(message, ...args);
    }
  },
};
